/** Công nợ — báo cáo tuổi nợ. Real /api/v1/billing/receivables. */
import { apiClient } from "./client";
import { downloadServerCsv } from "./reports";

export interface AgingBucket {
  bucket: string; // "0-30" | "31-60" | "61-90" | "90+"
  count: number;
  amount: number;
}

export interface Debtor {
  patientId: string;
  patientName: string;
  invoiceCount: number;
  balance: number;
  maxAgeDays: number;
  oldestIssuedAt: string | null;
}

export interface ReceivablesReport {
  totalOutstanding: number;
  aging: AgingBucket[];
  debtors: Debtor[];
}

export const receivablesApi = {
  report(): Promise<ReceivablesReport> {
    return apiClient.get<ReceivablesReport>("/v1/billing/receivables").then((r) => r.data);
  },
  /** #19865 — xuất CSV danh sách con nợ PHÍA SERVER: cùng quyền, cùng danh sách, có dòng kiểm toán. */
  exportCsv(): Promise<void> {
    return downloadServerCsv("/v1/billing/receivables/export", {}, "cong-no.csv");
  },
};

export const receivablesQueryKeys = {
  report: () => ["billing-receivables"] as const,
};
